export default class Calculator {
  /*
   * Fires first
   */
  constructor() {

    // Add events
    this.addEvents();
  }

  /*
   * Add events
   */
  addEvents() {

    //show modal when click on element with class js-open-modal-contact
    $('.js-open-modal-contact').on('click', (e) => {
      e.preventDefault();
      $('#contactModal').modal('show')
    });


    $('.js-calculator-checkbox').on('change checkbox-change', function (e) {

      if (e.type !== 'checkbox-change') {
        $('.js-calculator-checkbox').not(this).prop('checked', false).trigger('checkbox-change');
      }

      if ($(this).is(':checked')) {
        $(this).closest('.calculator__row').find('.calculator-input input').prop('disabled', false);
      } else {
        $(this).closest('.calculator__row').find('.calculator-input input').prop('disabled', true).val('').valid();
      }
    });

    $.validator.addMethod('required-if-enabled', function (value, element, params) {
      return (
        element.disabled
        || $.validator.methods.required.call(this, value, element, params)
      );
    }, $.validator.messages.required);

    $('#tooling-calculator').validate({
      rules: {
        'calculator_checkbox[]': {
          required: true,
          maxlength: 1,
        },
        'tablets_diameter': 'required-if-enabled',
        'tablets_depth': 'required-if-enabled',
        'caplets_length': 'required-if-enabled',
        'caplets_width': 'required-if-enabled',
        'caplets_depth': 'required-if-enabled',
        // 'capsules_length': 'required-if-enabled',
        // 'capsules_diameter': 'required-if-enabled',
        'capsules_size': 'required-if-enabled',
        'softgels_oval_size': 'required-if-enabled',
        'softgels_oblong_size': 'required-if-enabled',
      },
      messages: {
        'calculator_checkbox[]': {
          required: 'You must select one checkbox',
          maxlength: 'Please select one checkbox',
        },
      },

      errorElement: 'div',
      errorLabelContainer: '.calculator__error',

      submitHandler: function () {
        //var $success_response = '<h2>You’re a match!</h2>';
        //var $failure_response = '<h2>It looks like you may require a custom solution</h2>';

        // var $success_response = '<h2>You’re a match!</h2>' + '<button type="button" class="btn--small" data-toggle="modal" data-target="#contactModal">Contact us to discuss</button>';
        // var $failure_response = '<h2>It looks like you may require a custom solution</h2>' + '<button type="button" class="btn--small" data-toggle="modal" data-target="#contactModal">Contact us to discuss</button>';

        var $isMatch = false;
        var $message = '';

        // Tablets checkbox
        if ($('#tablets_checkbox').is(':checked')) {
          let $tablets_diameter = $('#tablets_diameter').val();
          let $tablets_depth = $('#tablets_depth').val();

          if ($tablets_diameter >= 5.25 && $tablets_diameter <= 21.2 && $tablets_depth >= 2.5 && $tablets_depth <= 11.54) {
            // Response (Your a match)
            $isMatch = true;
          } else {
            // Response (Your not a match)
            $isMatch = false;
          }

          $message += 'Tablets \n';
          $message += 'Tablets diameter: ' + $tablets_diameter + '\n';
          $message += 'Tablets depth: ' + $tablets_depth;
        }

        // Caplets checkbox
        if ($('#caplets_checkbox').is(':checked')) {
          let $caplets_length = $('#caplets_length').val();
          let $caplets_width = $('#caplets_width').val();
          let $caplets_depth = $('#caplets_depth').val();

          if ($caplets_length >= 6.7 && $caplets_length <= 23.8 && $caplets_width >= 3.6 && $caplets_width <= 10.6 && $caplets_depth >= 2.95 && $caplets_depth <= 8.2) {
            // Response (Your a match)
            $isMatch = true;
          } else {
            // Response (Your not a match)
            $isMatch = false;
          }

          $message += 'Caplets \n';
          $message += 'Caplets length: ' + $caplets_length + '\n';
          $message += 'Caplets width: ' + $caplets_width + '\n';
          $message += 'Caplets depth: ' + $caplets_depth;
        }

        // Capsules checkbox
        if ($('#capsules_checkbox').is(':checked')) {
          let $capsules_size = parseFloat($('#capsules_size').val());

          if ($capsules_size <= 4 && $capsules_size >= 0) {
            // Response (Your a match)
            $isMatch = true;
          } else {
            // Response (Your not a match)
            $isMatch = false;
          }
          $message += 'Capsules \n';
          $message += 'Capsules size: ' + $capsules_size + '\n';

          // let $capsules_length = parseFloat( $('#capsules_length').val() );
          // let $capsules_diameter = parseFloat( $('#capsules_diameter').val() );
          // if ( $capsules_length >= 5.32 && $capsules_length <= 10 && $capsules_diameter >= 14.5 && $capsules_diameter <= 26.1 ) {
          //     // Response (Your a match)
          //     $isMatch = true;
          // } else {
          //     // Response (Your not a match)
          //     $isMatch = false;
          // }
          // $message += 'Capsules \n';
          // $message += 'Capsules length: ' + $capsules_length + '\n';
          // $message += 'Capsules diameter: ' + $capsules_diameter;
        }

        // Softgels oval
        if ($('#softgels_oval_checkbox').is(':checked')) {
          let $softgels_oval_size = $('#softgels_oval_size').val();

          if ($softgels_oval_size >= 5 && $softgels_oval_size <= 16) {
            // Response (Your a match)
            $isMatch = true;
          } else {
            // Response (Your not a match)
            $isMatch = false;
          }

          $message += 'Softgels oval\n';
          $message += 'Softgels size: ' + $softgels_oval_size + '\n';
        }

        // Softgels oblong
        if ($('#softgels_oblong_checkbox').is(':checked')) {
          let $softgels_oblong_size = $('#softgels_oblong_size').val();

          if ($softgels_oblong_size >= 0 && $softgels_oblong_size <= 5) {
            // Response (Your a match)
            $isMatch = true;
          } else {
            // Response (Your not a match)
            $isMatch = false;
          }

          $message += 'Softgels size\n';
          $message += 'Softgels size: ' + $softgels_oblong_size + '\n';
        }


        $('.calculator__response').html('<h2>Calculating...</h2>');
        if ($isMatch) {
          //$('.calculator__response').html( $success_response );
          window.location.href = window.location.origin + '/tooling-calculator/youre-a-match/';
        } else {
          //$('.calculator__response').html( $failure_response );
          window.location.href = window.location.origin + '/tooling-calculator/require-a-custom-solution/';
        }

        $('html, body').animate({
          scrollTop: $('.calculator').offset().top - 90,
        }, 600);

        $('.wpcf7-textarea').val($message);
      },
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/calculator.js